document.addEventListener('DOMContentLoaded',function(){
  /* Fallback only. If a real Shopify Navigation item named "Pagal kainą" exists, this script does nothing. */
  var hasEditablePriceMenu=Array.from(document.querySelectorAll('.nav--desktop .nav-link')).some(function(link){
    return (link.textContent||'').trim().toLowerCase().indexOf('pagal kainą')!==-1;
  });
  if(hasEditablePriceMenu) return;

  var priceItems=[
    {label:'Dovanos iki 15€',url:'/collections/dovanos-iki-15-euru',badge:'15€'},
    {label:'Dovanos iki 25€',url:'/collections/dovanos-iki-25-euru',badge:'25€'},
    {label:'Dovanos iki 40€',url:'/collections/dovanos-iki-40-euru',badge:'40€'},
    {label:'Premium',url:'/collections/premium',badge:'★'}
  ];

  function desktopMenu(){
    var desktopNav=document.querySelector('.nav--desktop');
    if(!desktopNav||document.querySelector('.nav-price-menu')) return;
    var occasion=desktopNav.querySelector('.nav-dropdown--mega');
    var wrap=document.createElement('div');
    wrap.className='nav-dropdown nav-dropdown--mega nav-price-menu';
    wrap.setAttribute('data-dropdown','');
    wrap.innerHTML='<a href="/collections" class="nav-link" aria-haspopup="true" aria-expanded="false">Pagal kainą <svg class="nav-chev" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg></a><div class="mega-menu" role="menu"><div class="mega-menu__head"><span class="mega-menu__eyebrow">Dovanos pagal kainą</span><span class="mega-menu__text">Rinkitės pagal biudžetą – nuo mažų simbolinių dovanų iki premium rinkinių.</span></div><div class="mega-grid"></div></div>';
    var grid=wrap.querySelector('.mega-grid');
    priceItems.forEach(function(item){
      var a=document.createElement('a');
      a.href=item.url;
      a.className='mega-item';
      a.setAttribute('role','menuitem');
      a.innerHTML='<span class="mega-item__icon price-menu-badge">'+item.badge+'</span><span class="mega-item__label">'+item.label+'</span>';
      grid.appendChild(a);
    });
    if(occasion&&occasion.nextSibling){desktopNav.insertBefore(wrap,occasion.nextSibling);}else{desktopNav.appendChild(wrap);}
  }

  function mobileMenu(){
    var hasEditableMobile=Array.from(document.querySelectorAll('.mob-nav-list summary span,.mob-nav-list a')).some(function(el){
      return (el.textContent||'').trim().toLowerCase().indexOf('pagal kainą')!==-1;
    });
    if(hasEditableMobile) return;
    var list=document.querySelector('.mob-nav-list');
    if(!list||document.querySelector('.mob-price-menu')) return;
    var details=document.createElement('details');
    details.className='mob-disclosure mob-price-menu';
    details.innerHTML='<summary><span>Pagal kainą</span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg></summary><div class="mob-disclosure__body"></div>';
    var body=details.querySelector('.mob-disclosure__body');
    priceItems.forEach(function(item){
      var a=document.createElement('a');
      a.href=item.url;
      a.className='mob-sub-pill';
      a.textContent=item.label;
      body.appendChild(a);
    });
    var firstDisclosure=list.querySelector('.mob-disclosure');
    if(firstDisclosure&&firstDisclosure.nextSibling){list.insertBefore(details,firstDisclosure.nextSibling);}else{list.appendChild(details);}
  }

  desktopMenu();
  mobileMenu();
});
